<div class="flex min-w-0 flex-auto flex-col">
  
    <div class="bg-default flex flex-col items-start px-6 mt-8 sm:flex-row sm:items-center sm:justify-between md:px-8">
        <div class="text-4xl font-extrabold leading-none tracking-tight">Reports</div>
        <div class="flex justify-end">
            <button
                mat-raised-button
                color="primary"
                (click)="downloadReport()"
                class="flex items-center bg-purple-600 hover:bg-purple-700 text-white font-medium py-3 px-6 rounded-full shadow-md hover:shadow-lg transition-all duration-200"
                [disabled]="dataSource.data.length === 0 || isLoading"
            >
                <mat-icon class="mr-2 text-white">download</mat-icon>
                {{ isLoading ? 'Downloading...' : 'Download Report' }}
            </button>
        </div>
    </div>

    <div class="-mt-px flex-auto">
        <div class="mx-auto w-full p-8">
            <div class="">
                <form
                    [formGroup]="reportForm"
                    (ngSubmit)="resetPaginationAndSearch()"
                    class="grid grid-cols-4 gap-4 mb-5"
                >
                    <mat-form-field>
                        <mat-label>Venue</mat-label>
                        <mat-select formControlName="venueId" (selectionChange)="onVenueChange($event.value)">
                            <mat-option [value]="''">All Venues</mat-option>
                            @for (venue of venues; track venue) {
                                <mat-option [value]="venue._id">{{venue.name}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Court</mat-label>
                        <mat-select formControlName="courtId" (selectionChange)="resetPaginationAndSearch()">
                            <mat-option [value]="''">All Courts</mat-option>
                            @for (court of courts; track court) {
                                <mat-option [value]="court._id">{{court.name}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-full">
                        <mat-label>Booking Status</mat-label>
                        <mat-select [formControlName]="'status'" (selectionChange)="resetPaginationAndSearch()">
                            <mat-option [value]="''">All</mat-option>
                            <mat-option [value]="'tentative'">Tentative</mat-option>
                            <mat-option [value]="'confirmed'">Confirmed</mat-option>
                            <mat-option [value]="'completed'">Completed</mat-option>
                            <mat-option [value]="'maintenance'">Maintenance</mat-option>
                            <mat-option [value]="'canceled'">Canceled</mat-option>
                            <mat-option [value]="'no_show'">No Show</mat-option>
                            <mat-option [value]="'expired'">Expired</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Select Date</mat-label>
                        <mat-date-range-input
                            [rangePicker]="campaignOnePicker"
                            [comparisonStart]="reportForm.value.startDate"
                            [comparisonEnd]="reportForm.value.endDate"
                        >
                            <input
                                matStartDate
                                placeholder="Start date"
                                formControlName="startDate"
                                (dateChange)="resetPaginationAndSearch()"
                            >
                            <input
                                matEndDate
                                placeholder="End date"
                                formControlName="endDate"
                                (dateChange)="resetPaginationAndSearch()"
                            >
                        </mat-date-range-input>
                        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle
                            matIconSuffix
                            [for]="campaignOnePicker"
                        ></mat-datepicker-toggle>
                        <mat-date-range-picker #campaignOnePicker></mat-date-range-picker>
                    </mat-form-field>
                </form>
            </div>

            <!-- FIXED: Correct condition for showing table -->
            <div *ngIf="hasSearched && dataSource.data.length > 0" class="bg-card rounded-2xl p-1 shadow">
                <div class="bg-card w-full text-left border-separate border-spacing-0 mat-elevation-z0">
                    <table
                        mat-table
                        [dataSource]="dataSource"
                        class="w-full custom-table"
                    >

                        <ng-container matColumnDef="bookingId">
                            <th mat-header-cell *matHeaderCellDef class="font-medium py-3 px-4 bg-gray-50 text-gray-700">
                                Booking ID
                            </th>
                            <td mat-cell *matCellDef="let element" class="py-3 px-4 font-mono text-sm">
                                {{element.bookingId || element._id}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="venue">
                            <th mat-header-cell *matHeaderCellDef class="font-medium py-3 px-4 bg-gray-50 text-gray-700">
                                Venue
                            </th>
                            <td mat-cell *matCellDef="let element" class="py-3 px-4">
                                <div class="flex items-center">
                                    <mat-icon class="text-gray-400 mr-2 icon-size-4">business</mat-icon>
                                    <div>
                                        <div class="font-medium">{{getVenueName(element.venueId)}}</div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="courtId">
                            <th mat-header-cell *matHeaderCellDef class="font-medium py-3 px-4 bg-gray-50 text-gray-700">
                                Court
                            </th>
                            <td mat-cell *matCellDef="let element" class="py-3 px-4">
                                <div class="flex items-center">
                                    <div>
                                        <div class="font-medium">{{getCourtName(element.courtId)}}</div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="start">
                            <th mat-header-cell *matHeaderCellDef class="font-medium py-3 px-4 bg-gray-50 text-gray-700">
                                Date
                            </th>
                            <td mat-cell *matCellDef="let element" class="py-3 px-4">
                                {{formatProductDate(element.start)}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="time">
                            <th mat-header-cell *matHeaderCellDef class="font-medium py-3 px-4 bg-gray-50 text-gray-700">
                                Time
                            </th>
                            <td mat-cell *matCellDef="let element" class="py-3 px-4">
                                <div class="flex items-center">
                                    <mat-icon class="text-gray-400 mr-2 icon-size-4">access_time</mat-icon>
                                    {{element.start | date:'h:mm a'}} - {{element.end | date:'h:mm a'}}
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="durationHours">
                            <th mat-header-cell *matHeaderCellDef class="font-medium py-3 px-4 bg-gray-50 text-gray-700">
                                Duration
                            </th>
                            <td mat-cell *matCellDef="let element" class="py-3 px-4">
                                <div class="flex items-center">
                                    <span class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                                        {{element.durationHours}}
                                    </span>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="total">
                            <th mat-header-cell *matHeaderCellDef class="font-medium py-3 px-4 bg-gray-50 text-gray-700">
                                Price
                            </th>
                            <td mat-cell *matCellDef="let element" class="py-3 px-4 font-medium">
                                <div class="flex items-center">
                                    <span class="text-green-600">{{formatAedCurrency(element.total)}}</span>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="font-medium py-3 px-4 bg-gray-50 text-gray-700">
                                Status
                            </th>
                            <td mat-cell *matCellDef="let element" class="py-3 px-4">
                                <span
                                    [class]="getStatusClass(element.status)"
                                    class="px-3 py-1 rounded-full text-xs font-medium flex items-center justify-center w-24"
                                >
                                    <mat-icon class="mr-1 icon-size-4">{{getStatusIcon(element.status)}}</mat-icon>
                                    {{formatBookingStatusLabel(element.status)}}
                                </span>
                            </td>
                        </ng-container>

                        <!-- ADDED: Actions Column for Viewing Booking Details -->
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef class="font-medium py-3 px-4 bg-gray-50 text-gray-700 text-center">
                                Actions
                            </th>
                            <td mat-cell *matCellDef="let element" class="py-3 px-4 text-center">
                                <button
                                    mat-icon-button
                                    color="primary"
                                    (click)="viewDetails(element); $event.stopPropagation()"
                                    class="hover:bg-blue-50 rounded-full transition-colors duration-200"
                                    matTooltip="View Booking Details"
                                >
                                    <mat-icon class="text-blue-600">visibility</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <!-- FIXED: Updated displayedColumns to include actions -->
                        <tr 
                            mat-header-row 
                            *matHeaderRowDef="displayedColumns" 
                            class="h-12"
                        ></tr>
                        <tr 
                            mat-row 
                            *matRowDef="let row; columns: displayedColumns;" 
                            (click)="viewDetails(row)"
                            class="h-14 hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
                        ></tr>
                    </table>

                    <!-- FIXED: Paginator should be outside the table but inside the card -->
                    <mat-paginator
                        [length]="totalItems"
                        [pageSize]="pageSize"
                        [pageIndex]="pageIndex"
                        [pageSizeOptions]="[5, 10, 20, 50, 100]"
                        (page)="onPageChange($event)"
                        showFirstLastButtons
                        aria-label="Select page of bookings"
                        class="bg-gray-50 border-t"
                    >
                    </mat-paginator>
                </div>
            </div>

            <!-- FIXED: Correct condition for no results -->
            <div *ngIf="hasSearched && dataSource.data.length === 0 && !isLoading" class="bg-card rounded-2xl p-6 shadow mt-6">
                <div class="text-center py-8">
                    <mat-icon class="text-gray-400 icon-size-16">search_off</mat-icon>
                    <h3 class="mt-2 text-lg font-medium">No bookings found</h3>
                    <p class="text-gray-500 mt-1">
                        Try adjusting your search filters to find what you're looking for.
                    </p>
                </div>
            </div>

            <div *ngIf="isLoading" class="bg-card rounded-2xl p-6 shadow mt-6">
                <div class="flex items-center justify-center py-8">
                    <mat-spinner diameter="40"></mat-spinner>
                    <span class="ml-4 text-gray-600">Loading bookings...</span>
                </div>
            </div>

        </div>
    </div>
</div>
